
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ProductDetailPage = lazy(() => import('../pages/products/[id]/page'));
const CocopeatProductPage = lazy(() => import('../pages/products/1/page'));
const Product2Page = lazy(() => import('../pages/products/2/page'));
const Product3Page = lazy(() => import('../pages/products/3/page'));
const Product4Page = lazy(() => import('../pages/products/4/page'));
const Product5Page = lazy(() => import('../pages/products/5/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const PartnersPage = lazy(() => import('../pages/partners/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const CatalogPage = lazy(() => import('../pages/catalog/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/products',
    element: <ProductsPage />
  },
  {
    path: '/products/:id',
    element: <ProductDetailPage />
  },
  {
    path: '/products/1',
    element: <CocopeatProductPage />
  },
  {
    path: '/products/2',
    element: <Product2Page />
  },
  {
    path: '/products/3',
    element: <Product3Page />
  },
  {
    path: '/products/4',
    element: <Product4Page />
  },
  {
    path: '/products/5',
    element: <Product5Page />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/projects',
    element: <ProjectsPage />
  },
  {
    path: '/news',
    element: <NewsPage />
  },
  {
    path: '/partners',
    element: <PartnersPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/catalog',
    element: <CatalogPage />
  },
  {
    path: '/privacy',
    element: <PrivacyPolicyPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
